import type { HermesGuardFn } from '@/router/guards/types'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

import { GUEST_PHOTO_REVIEWER_FLAG } from '../../types'

// Every photo-moderation route name must be listed here — a route absent from
// this set skips the flag check and is reachable with the flag off.
const PHOTO_MODERATION_ROUTES = new Set([
  'photo-moderation.index',
  'photo-moderation.detail',
])

export const checkGuestPhotoReviewerFeatureFlag: HermesGuardFn = async (to) => {
  if (!PHOTO_MODERATION_ROUTES.has(to.name as string)) return undefined

  const featureFlags = useFeatureFlags()

  // photo-moderation is a top-level admin route with no brandId in scope, so
  // redirect to the param-less brands overview — not brand.home (needs brandId).
  if (!featureFlags.isEnabled(GUEST_PHOTO_REVIEWER_FLAG)) {
    return { name: 'brands' }
  }

  return undefined
}
